export default {
  age: '年龄',
  time: '时间',
}